import toMap from '~/misc/toMap';

export default toMap([
  'WINDOW_FOCUSED',
  'WINDOW_BLURRED',
  'SWITCH_TIMES',
  'GLOBAL_PARAMS'
]);



// WEBPACK FOOTER //
// ./src/modules/window/types.js